import ReconnectingEventSource, {
  ReconnectingEventSourceInit,
} from 'reconnecting-eventsource';

import { HEARTBEAT_EVENT, HEARTBEAT_TIMEOUT } from './constants';

type THeartbeatEventSourceOpts = {
  afterReconnect?: () => void | Promise<void>;
};

export class HeartbeatEventSource extends ReconnectingEventSource {
  timeout?: ReturnType<typeof setTimeout>;
  configuration?: ReconnectingEventSourceInit & THeartbeatEventSourceOpts;

  constructor(
    url: string | URL,
    configuration?: ReconnectingEventSourceInit & THeartbeatEventSourceOpts,
  ) {
    super(url, configuration);
    this.configuration = configuration;
    this.addEventListener(HEARTBEAT_EVENT, this.refreshTimeout);
    this.refreshTimeout();
  }

  refreshTimeout = () => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.reconnect, HEARTBEAT_TIMEOUT);
  };

  reconnect = () => {
    this._eventSource?.close();
    this._eventSource = null;
    this._start();
    this?.configuration?.afterReconnect?.();
  };

  close() {
    if (this.timeout) clearTimeout(this.timeout);
    this.removeEventListener(HEARTBEAT_EVENT, this.refreshTimeout);
    super.close();
  }
}
